import { render, staticRenderFns } from "./AvailableInvest.vue?vue&type=template&id=2ba2f284&scoped=true&"
import script from "./AvailableInvest.vue?vue&type=script&lang=ts&"
export * from "./AvailableInvest.vue?vue&type=script&lang=ts&"
import style0 from "./AvailableInvest.vue?vue&type=style&index=0&id=2ba2f284&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba2f284",
  null
  
)

export default component.exports